import { GET_TASKS_SUCCESS, GET_TASK_BY_ID_SUCCESS, CREATE_TASK_COMMENT_SUCCESS, GET_TASK_COMMENTS_SUCCESS } from './tasks.type';

const initialState = {
    tasksList: [],

    taskById: null,
    comments: [],
    commentCount: 0,
};

export const tasksReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_TASKS_SUCCESS:
            return {
                ...state,
                tasksList: action.payload,
            };

        case GET_TASK_BY_ID_SUCCESS:
            return {
                ...state,
                taskById: action.payload,
            };

        case GET_TASK_COMMENTS_SUCCESS:
            return {
                ...state,
                comments: action.payload.comments,
                commentCount: action.payload.count,
            };

        case CREATE_TASK_COMMENT_SUCCESS:
            return {
                ...state,
                comments: [action.payload, ...state.comments],
                commentCount: state.commentCount + 1,
            };

        default:
            return state;
    }
};
